import { createContext } from "react";

const DF_OT0059Context = createContext();

export { DF_OT0059Context };
